module.exports = __webpack_public_path__ + "static/writing-a-cmr-3c6f26a12ac331fc63d44607ce1a9a49.jpg";